import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, DashboardModule,
} from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import EditorialPublicationListItem from './EditorialPublicationListItem'
import useEditorialPublications from './hooks/useEditorialPublications'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Filter by Publication Title',
    },
  ]
}

const EditorialPublications = (props) => {
  const { serviceProductPayload } = props
  const {
    callbacks: {
      manageServiceProductPublications,
      togglePublication,
    },
    loading,
    serviceProduct,
  } = serviceProductPayload

  const filterPayload = useFilters()
  const { pageFilters } = filterPayload

  const {
    filteredPublications,
    hasEditorialPublications,
    hasFilteredPublications,
  } = useEditorialPublications(serviceProduct, pageFilters)

  return (
    <DashboardModule
      boxProps={{ id: 'realhub-nav-editorial-publications' }}
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={hasEditorialPublications && <DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Editorial Publications"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      <Box flexDirection="column">
        {!loading && !hasFilteredPublications && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Editorial Publications present.
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              Please adjust your filters or add a Publication.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {!loading && hasFilteredPublications && (
          <DashboardModule.ScrollableSection flexDirection="column">
            {filteredPublications.map(publication => (
              <EditorialPublicationListItem
                callbacks={{
                  togglePublication: () => togglePublication(publication.id, 'editorial'),
                }}
                key={publication.id}
                publication={publication}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.Footer boxProps={{ borderTop: loading ? 'none' : '1px solid' }}>
          <DashboardModule.FooterRight>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => manageServiceProductPublications({ optionsKey: 'editorial' })}
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Add Publication
            </Button>
          </DashboardModule.FooterRight>
        </DashboardModule.Footer>
      </Box>
    </DashboardModule>
  )
}

EditorialPublications.propTypes = {
  serviceProductPayload: PropTypes.object.isRequired,
}

export default EditorialPublications
